export enum OtOrganisationType {
  NotSet = 'Not Set',
  Principal = 'Principal',
  HeadContractor = 'Head Contractor',
  ProjectManager = 'Project Manager',
  Subcontractor = 'Subcontractor',
  DevelopmentManagementConsultancy = 'Development Management Consultancy',
}
